import { useEffect, useState } from "react";
import useToken from "../../auth/useToken";
import {  exchangeRateService } from "../../../services/administration/exchangeRateService";
import { ExchangeRate } from "../../../types/features/administration/Setting";

export default function useExchangeRates() {
  const [rates, setRates] = useState<ExchangeRate[]>([]);
  const [activeRate, setActiveRate] = useState<ExchangeRate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const getRates = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const ratesData = await exchangeRateService.getAllRates(token);
      setRates(ratesData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const getActiveRate = async () => {
    if (!token) return;

    try {
      const activeRateData = await exchangeRateService.getActiveRate(token);
      setActiveRate(activeRateData);
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const createRate = async (rate: Omit<ExchangeRate, "id" | "created_at" | "updated_at">) => {
    if (!token) return;

    try {
      await exchangeRateService.createRate(rate, token);
      await getRates();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updateRate = async (
    fromCurrency: string,
    toCurrency: string,
    updates: { rate?: number; status?: "ACTIVE" | "INACTIVE" }
  ) => {
    if (!token) return;

    try {
      await exchangeRateService.updateRate(fromCurrency, toCurrency, updates, token);
      await getRates();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const deleteRate = async (fromCurrency: string, toCurrency: string) => {
    if (!token) return;

    try {
      await exchangeRateService.deleteRate(fromCurrency, toCurrency, token);
      await getRates();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  useEffect(() => {
    getRates();
    getActiveRate();
  }, [token]);

  return {
    rates,
    activeRate,
    loading,
    error,
    getRates,
    getActiveRate,
    createRate,
    updateRate,
    deleteRate,
  };
}
